const countrySettings = {
  malaysia: {
    smallBox: {
      volume: 2001,
      itemQuantityLimit: {
        xs: 20,
        s: 9,
        m: 4,
        l: 2,
        xl: 0,
      },
    },
    mediumBox: {
      volume: 4001,
      itemQuantityLimit: {
        xs: 25,
        s: 15,
        m: 6,
        l: 3,
        xl: 1,
      },
    },
    bigBox: {
      volume: 9198,
      itemQuantityLimit: {
        xs: 30,
        s: 25,
        m: 10,
        l: 5,
        xl: 2,
      },
    }
  },
  singapore: {
    smallBox: {
      volume: 2430,
      itemQuantityLimit: {
        xs: 20,
        s: 9,
        m: 4,
        l: 2,
        xl: 0,
      },
    },
    mediumBox: {
      volume: 4001,
      itemQuantityLimit: {
        xs: 25,
        s: 15,
        m: 6,
        l: 3,
        xl: 1,
      },
    },
    bigBox: {
      volume: 7862,
      itemQuantityLimit: {
        xs: 30,
        s: 25,
        m: 10,
        l: 5,
        xl: 2,
      },
    },
  }
}

const getTotalVolumetric = (xs, s, m, l, xl) => {
  // assume upper limit
  const itemSizeKey = {
    xs: 100,
    s: 200,
    m: 500,
    l: 1000,
    xl: 3000,
  }

  return (
    itemSizeKey.xs * xs +
    itemSizeKey.s * s +
    itemSizeKey.m * m +
    itemSizeKey.l * l +
    itemSizeKey.xl * xl
  );
};

const getBoxSize = (country = "singapore", xs = 0, s = 0, m = 5, l = 0, xl = 2) => {
  const inputTotalVolumetric = getTotalVolumetric(xs, s, m, l, xl);
  const settings = countrySettings[country]

  country = country.toLowerCase();
  if (
    inputTotalVolumetric <= settings.smallBox.volume &&
    xs <= settings.smallBox.itemQuantityLimit.xs &&
    s <= settings.smallBox.itemQuantityLimit.s &&
    m <= settings.smallBox.itemQuantityLimit.m &&
    l <= settings.smallBox.itemQuantityLimit.l &&
    xl <= settings.smallBox.itemQuantityLimit.xl
  ) {
    return "small";
  } else if (
    inputTotalVolumetric <= settings.mediumBox.volume &&
    xs <= settings.mediumBox.itemQuantityLimit.xs &&
    s <= settings.mediumBox.itemQuantityLimit.s &&
    m <= settings.mediumBox.itemQuantityLimit.m &&
    l <= settings.mediumBox.itemQuantityLimit.l &&
    xl <= settings.mediumBox.itemQuantityLimit.xl
  ) {
    return "medium";
  } else if (
    inputTotalVolumetric <= settings.bigBox.volume &&
    xs <= settings.bigBox.itemQuantityLimit.xs &&
    s <= settings.bigBox.itemQuantityLimit.s &&
    m <= settings.bigBox.itemQuantityLimit.m &&
    l <= settings.bigBox.itemQuantityLimit.l &&
    xl <= settings.bigBox.itemQuantityLimit.xl
  ) {
    return "big";
  } else {
    return "big-exceed";
  }
}

export default getBoxSize;